module.exports = __webpack_public_path__ + "e7072cca090b8e8839139e4a7a13bc74.jpg";